import { Fragment } from "react";
import { getAppPermissionsTemplate } from "../../templates/templates";
import { EditorUser, HoldingUserPermissions } from "../../types";
import { AppDispatch } from "../hooks";
import { FeatureGroupPermissions } from "./FeatureGroupPermissions";
import { FeaturePermissions } from "./FeaturePermissions";
import { classes } from "../../../../../../shared/react/react";
import { getObjectEntries } from "../../../../../../shared/utils/objects";

interface Props {
    users: EditorUser[]
    app: keyof HoldingUserPermissions
    dispatch: AppDispatch
    readOnly: boolean
    currentUserId: number
}

export function AppPermissions({ users, app, dispatch, readOnly, currentUserId }: Props) {

    const template = getAppPermissionsTemplate(app)

    const setPermissions = (key: string, userId: number, values: {}) => {

        const updates = [{
            key,
            values
        }]

        dispatch({
            type: "updatePermissions",
            payload: {
                userId,
                updates
            }
        })
    }


    return <>

        <div className="group app" style={{ gridColumn: 1 }}>
            <span>
                {template.name}
            </span>
        </div>

        {
            users.map((user, index) =>
                <div
                    key={user.userId}
                    className={classes("group user", (index === (users.length - 1) && "last"))}
                    style={{ gridColumn: (index + 2) }}>

                    {
                        (!readOnly) &&
                        <FeatureGroupPermissions
                            app={app}
                            dispatch={dispatch}
                            templates={template.permissions}
                            user={user}
                        />
                    }

                </div>
            )
        }

        {
            getObjectEntries(template.permissions).map(([featureKey, permTemplate]) => {

                return <Fragment key={featureKey}>

                    <div className="row-header feature" style={{ gridColumn: 1 }}>
                        {permTemplate.name}
                    </div>

                    {
                        users.map((user, index) => {

                            const key = `${app}.${featureKey}`

                            const available = permTemplate.checkDependencies
                                ? permTemplate.checkDependencies(user.holdingPermissions)
                                : true

                            const self = user.userId === currentUserId

                            return <div key={user.userId} className={classes("cell perm", self && "self")} style={{ gridColumn: (index + 2) }}>
                                <FeaturePermissions
                                    permissions={user.holdingPermissions[key]}
                                    template={permTemplate}
                                    available={available}
                                    setPermissions={values => setPermissions(key, user.userId, values)}
                                    readOnly={readOnly}
                                />
                            </div>

                        })
                    }

                </Fragment>


            })
        }
    </>
}